var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 44.6",
    style: {
      enableBackground: "new 0 0 45 44.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,0.1C1.4-0.2,0.4,0.3,0.1,1.2c-0.3,0.9,0.2,2,1.1,2.3l0.6,0.2c1.6,0.5,2.7,0.9,3.5,1.3 c0.7,0.3,1.1,0.6,1.3,0.9S6.9,6.5,7,7.3c0.1,0.9,0.1,2,0.1,3.7v6.4c0,3.2,0,5.9,0.3,7.9c0.3,2.1,0.9,4,2.3,5.4 c1.4,1.4,3.2,2,5.4,2.3c2.1,0.3,4.7,0.3,7.9,0.3h16.8c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H23.2c-3.4,0-5.8,0-7.6-0.2 c-1.8-0.2-2.7-0.7-3.3-1.3c-0.6-0.6-0.9-1.3-1.2-2.6h24.1c2.3,0,3.4,0,4.3-0.6c0.9-0.6,1.3-1.6,2.2-3.7l1-2.4 c1.9-4.5,2.9-6.7,1.8-8.4c-1.1-1.6-3.5-1.6-8.4-1.6H10.7c0-0.7,0-1.4-0.1-2c-0.1-1.2-0.4-2.2-1.1-3.2S7.9,2.2,6.8,1.7 c-1-0.5-2.2-0.9-3.7-1.4L2.3,0.1L2.3,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,37.5c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6S11.3,43,11.3,41S12.9,37.5,14.9,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,37.5c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6S32.7,43,32.7,41S34.3,37.5,36.3,37.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.d68c8059babecbe7dba40c56e3399ba6.svg";
export { ForwardRef as ReactComponent };